import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { Box, Flex, Button, Text, LoadingOverlay, ActionIcon, Tabs, Drawer, Menu, Modal, ScrollArea, Divider, Affix, Transition } from '@mantine/core'
import { IconPencilMinus, IconRefresh, IconTrash, IconBrandWhatsapp, IconPrinter, IconShare, IconArrowUp } from '@tabler/icons-react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getOrderDetail } from '../../../../store/orderDetail'
import { getOrderItems } from '../../../../store/orderItems'
import { deleteOrder, getOrderCount as getOrderCountService } from '../../../../services/orders'
import OrderSummary from '../../../../component/pages/Orders/Detail/OrderSummary'
import OrderGeneralInfo from '../../../../component/pages/Orders/Detail/OrderGeneralInfo'
import OrderLogistic from '../../../../component/pages/Orders/Detail/OrderLogistic'
import OrderLogisticCharges from '../../../../component/pages/Orders/Detail/OrderLogisticCharges'
import OrderCustomCharges from '../../../../component/pages/Orders/Detail/OrderCustomCharges'
import OrderAdditionalInfo from '../../../../component/pages/Orders/Detail/OrderAdditionalInfo'
import OrderDocuments from '../../../../component/pages/Orders/Detail/OrderDocuments'
import OrderDropshipInfo from '../../../../component/pages/Orders/Detail/OrderDropshipInfo'
import OrderStatusHistory from '../../../../component/pages/Orders/Detail/OrderStatusHistory'
import OrderProductItems from '../../../../component/pages/Orders/Detail/OrderProductItems'
import OrderInvoicesDetails from '../../../../component/pages/Orders/Detail/OrderInvoicesDetails'
import OrderPaymentHistory from '../../../../component/pages/Orders/Detail/OrderPaymentHistory'
import OrderProofPayment from '../../../../component/pages/Orders/Detail/OrderProofPayment'
import OrderPackageShipment from '../../../../component/pages/Orders/Detail/OrderPackageShipment'
import OrderPackageItems from '../../../../component/pages/Orders/Detail/OrderPackageItems'
import OrderQualityControl from '../../../../component/pages/Orders/Detail/OrderQualityControl'
import FormAdjustOrderCode from '../../../../component/pages/Orders/Detail/Form/FormAdjustOrderCode'
import FormBroadcastWhatsapp from '../../../../component/pages/Orders/Detail/Form/FormBroadcastWhatsapp'
import FormSalesOrder from '../../../../component/pages/Orders/Detail/Form/FormSalesOrder'
import FormShareOrder from '../../../../component/pages/Orders/Detail/Form/FormShareOrder'
import FormShareReviewOrder from '../../../../component/pages/Orders/Detail/Form/FormShareReviewOrder'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import { useNavigate } from 'react-router-dom'
import { useWindowScroll } from '@mantine/hooks'

const defaultOrderTopTab = [
  {
    label: 'Summary',
    value: 'summary'
  },
  {
    label: 'General',
    value: 'general'
  },
  {
    label: 'Logistic',
    value: 'logistic'
  },
  {
    label: 'Logistic Charges',
    value: 'logisticCharges'
  },
  {
    label: 'Customs Charges (Tax)',
    value: 'customCharges'
  },
  {
    label: 'Additional',
    value: 'additionalInfo'
  },
  {
    label: 'Documents',
    value: 'documentOrders'
  },
  {
    label: 'Dropship',
    value: 'dropshipOrders'
  },
  {
    label: 'Order Status History',
    value: 'orderStatusHistory'
  },
]

const defaultOrderTopPanel = [
  {
    value: 'summary',
    component: OrderSummary,
  },
  {
    value: 'general',
    component: OrderGeneralInfo,
  },
  {
    value: 'logistic',
    component: OrderLogistic,
  },
  {
    value: 'logisticCharges',
    component: OrderLogisticCharges,
  },
  {
    value: 'customCharges',
    component: OrderCustomCharges,
  },
  {
    value: 'additionalInfo',
    component: OrderAdditionalInfo,
  },
  {
    value: 'documentOrders',
    component: OrderDocuments,
  },
  {
    value: 'dropshipOrders',
    component: OrderDropshipInfo,
  },
  {
    value: 'orderStatusHistory',
    component: OrderStatusHistory,
  },
]

const defaultOrderBottomTab = [
  {
    label: 'Products',
    value: 'product'
  },
  {
    label: 'Invoices Number Details',
    value: 'invoices'
  },
  {
    label: 'Payment History',
    value: 'paymentHistory'
  },
  {
    label: 'Proof Of Payment',
    value: 'proofPayment'
  },
  {
    label: 'Package Shipment',
    value: 'packageShipment'
  },
  {
    label: 'Package Items',
    value: 'packageItems'
  },
  {
    label: 'Quality Control (QC)',
    value: 'qualityControl'
  },
]

const defaultOrderBottomPanel = [
  {
    value: 'product',
    component: OrderProductItems,
  },
  {
    value: 'invoices',
    component: OrderInvoicesDetails,
  },
  {
    value: 'paymentHistory',
    component: OrderPaymentHistory,
  },
  {
    value: 'proofPayment',
    component: OrderProofPayment,
  },
  {
    value: 'packageShipment',
    component: OrderPackageShipment,
  },
  {
    value: 'packageItems',
    component: OrderPackageItems,
  },
  {
    value: 'qualityControl',
    component: OrderQualityControl,
  },
]

const orderTabCountField = {
  documentOrders: 'documentCount',
  product: 'itemCount',
  packageShipment: 'packageShipmentCount',
  proofPayment: 'proofOfPaymentCount',
  qualityControl: 'qualityControlCount',
}

const DetailOrder = () => {
  const [scroll, scrollTo] = useWindowScroll()
  const navigate = useNavigate()
  const { isLoadingOrder, summary } = useSelector(state => state.order_detail)
  const { isLoadingOrderItems } = useSelector(state => state.order_items)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [incognitoLayout, setIncognitoLayout] = useState(false)
  const [activeTopTab, setActiveTopTab] = useState('summary')
  const [activeBottomTab, setActiveBottomTab] = useState('product')
  const [openEditOrderCode, setOpenEditOrderCode] = useState(false)
  const [openFormBroadcastWhatsapp, setOpenFormBroadcastWhatsapp] = useState(false)
  const [openFormSalesOrder, setOpenFormSalesOrder] = useState(false)
  const [openShareOrder, setOpenShareOrder] = useState(false)
  const [openShareReviewOrder, setOpenShareReviewOrder] = useState(false)
  const [orderCount, setOrderCount] = useState({})

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Order',
      route: '/order/all'
    },
    {
      label: orderId,
      route: null
    },
  ]

  const getOrderCount = async () => {
    try {
      const response = await getOrderCountService(orderId)
      setOrderCount(response?.data?.order || {})
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    dispatch(getOrderDetail(orderId))
    dispatch(getOrderItems(orderId))
    getOrderCount()
    // eslint-disable-next-line
  }, [dispatch])

  const onCloseFormOrderCode = () => {
    setOpenEditOrderCode(false)
  }

  const onCloseFormBroadcastWA = () => {
    setOpenFormBroadcastWhatsapp(false)
  }

  const onCloseFormSalesOrder = () => {
    setOpenFormSalesOrder(false)
  }

  const onCloseModalShareOrder = () => {
    setOpenShareOrder(false)
  }
  const onCloseModalShareReviewOrder = () => {
    setOpenShareReviewOrder(false)
  }

  const goToOrderList = () => {
    navigate('/order/all')
  }

  const handleDeleteData = (orderId) => {
    modalDeleteData('Order', orderId, summary.orderCode, deleteOrder, goToOrderList)
  }

  const detailOrderLayout = (modeIncognito) => {
    if (!modeIncognito) {

      const getTabLabel = (val) => {
        const countField = orderTabCountField[val.value]
        if (!countField) return val.label
        return `${val.label} (${orderCount[countField] ?? 0})`
      }

      const mappingTopTabOrder = (dataTopTabs) => {
        const remapTopTabs = dataTopTabs.map((val, index) => {
          return (<Tabs.Tab key={index} value={val.value} style={{ color: val.value === activeTopTab ? 'red' : 'gray', fontWeight: val.value === activeTopTab ? 'bold' : '400' }}>{getTabLabel(val)}</Tabs.Tab>)
        })
        return remapTopTabs
      }
      
      const mappingTopPanelOrder = (dataTopPanels) => {
        const remapTopPanels = dataTopPanels.map((val, index) => {
          return (<Tabs.Panel key={index} value={val.value}><val.component /></Tabs.Panel>)
        })
        return remapTopPanels
      }

      const mappingBottomTabOrder = (dataBottomTabs) => {
        const remapBottomTabs = dataBottomTabs.map((val, index) => {
          return (<Tabs.Tab key={index} value={val.value} style={{ color: val.value === activeBottomTab ? 'red' : 'gray', fontWeight: val.value === activeBottomTab ? 'bold' : '400' }}>{getTabLabel(val)}</Tabs.Tab>)
        })
        return remapBottomTabs
      }
      
      const mappingBottomPanelOrder = (dataBottomPanels) => {
        const remapBottomPanels = dataBottomPanels.map((val, index) => {
          return (<Tabs.Panel key={index} value={val.value}><val.component /></Tabs.Panel>)
        })
        return remapBottomPanels
      }

      return (
        <Box my={20}>
          <Flex justify='space-between' align='center' my={8}>
            <Flex align='center' gap='xs'>
              <Text className={classes.titleLayout}>{summary.orderCode}</Text>
              <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditOrderCode(true)}>
                <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon>
            </Flex>
            <Flex align='center' gap='sm'>
              <ActionIcon variant="default" size='lg' onClick={() => dispatch(getOrderDetail(orderId))}>
                <IconRefresh style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon>
              <ActionIcon variant="default" size='lg' onClick={() => handleDeleteData(orderId)}>
                <IconTrash style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon>
              <Menu width={230} position="bottom-end" withArrow arrowPosition="center">
                <Menu.Target>
                  <Button size="sm" radius="md">Share</Button>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item
                    leftSection={<IconBrandWhatsapp stroke={1.5} size={14} />}
                    onClick={() => setOpenFormBroadcastWhatsapp(true)}
                    fw='600'
                    fz={11}
                  >
                    Broadcast WA to internal group
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconPrinter stroke={1.5} size={14} />}
                    onClick={() => setOpenFormSalesOrder(true)}
                    fw='600'
                    fz={11}
                  >
                    Sales Order / Quote PDF
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconShare stroke={1.5} size={14} />}
                    onClick={() => setOpenShareOrder(true)}
                    fw='600'
                    fz={11}
                  >
                    Share Order
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconShare stroke={1.5} size={14} />}
                    onClick={() => setOpenShareReviewOrder(true)}
                    fw='600'
                    fz={11}
                  >
                    Share Review
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          </Flex>
          <Box my={30}>
            <Tabs value={activeTopTab} keepMounted={false} onChange={setActiveTopTab}>
              <Tabs.List>
                {mappingTopTabOrder(defaultOrderTopTab)}
              </Tabs.List>

              {mappingTopPanelOrder(defaultOrderTopPanel)}
            </Tabs>
          </Box>

          <Divider size='sm' my='md' />

          <Box my={30}>
            <Tabs value={activeBottomTab} keepMounted={false} onChange={setActiveBottomTab}>
              <Tabs.List>
                {mappingBottomTabOrder(defaultOrderBottomTab)}
              </Tabs.List>

              {mappingBottomPanelOrder(defaultOrderBottomPanel)}
            </Tabs>
          </Box>
        </Box>
      )
    } else {
      return (
        <Box my={20}>
          <Flex justify='space-between' align='center'>
            <Text className={classes.titleLayout}>Incognito Mode</Text>
            <Button size="sm" radius="md" onClick={() => setIncognitoLayout(false)}>Quit</Button>
          </Flex>
        </Box>
      )
    }
  }


  return (
    <AuthLayout>
      <Box pos='relative'>
        <LoadingOverlay visible={isLoadingOrder && isLoadingOrderItems} zIndex={1000} overlayProps={{ radius: "sm", blur: 3 }} />
        {detailOrderLayout(incognitoLayout)}
        <Affix position={{ bottom: 20, left: 20 }}>
          <Transition transition="slide-up" mounted={scroll.y > 0}>
            {(transitionStyles) => (
              <Button
                size='xs'
                leftSection={<IconArrowUp size={16} />}
                style={transitionStyles}
                onClick={() => scrollTo({ y: 0 })}
              >
                Scroll to top
              </Button>
            )}
          </Transition>
        </Affix>
      </Box>
      <Drawer position='right' title='Edit order code and date' opened={openEditOrderCode} onClose={onCloseFormOrderCode} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustOrderCode onCloseForm={onCloseFormOrderCode} />
      </Drawer>
      <Modal opened={openFormBroadcastWhatsapp} onClose={onCloseFormBroadcastWA} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Broadcast Order Info To WhatsApp</Text>}  scrollAreaComponent={ScrollArea} withCloseButton={false}>
        <FormBroadcastWhatsapp idOrder={orderId} onCloseModal={onCloseFormBroadcastWA} />
      </Modal>
      <Modal opened={openFormSalesOrder} onClose={onCloseFormSalesOrder} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Share Sales Order / Quote PDF</Text>} withCloseButton={false}>
        <FormSalesOrder idOrder={orderId} onCloseModal={onCloseFormSalesOrder} />
      </Modal>
      <Modal opened={openShareOrder} onClose={onCloseModalShareOrder} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Share Order</Text>}  scrollAreaComponent={ScrollArea} withCloseButton={false}>
        <FormShareOrder idOrder={orderId} onCloseModal={onCloseModalShareOrder} />
      </Modal>
      <Modal opened={openShareReviewOrder} onClose={onCloseModalShareReviewOrder} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Share Review Link #{orderId} URL</Text>}  scrollAreaComponent={ScrollArea} withCloseButton={false}>
        <FormShareReviewOrder idOrder={orderId} onCloseModal={onCloseModalShareReviewOrder} />
      </Modal>
    </AuthLayout>
    
  )
}

export default DetailOrder